import { memo, useCallback, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import Button from "../../common/Button";
import classesCell from "./BodyCell.module.css";
import classes from "./MrqCoverLetterCell.module.css";
import { generateGlobalDownloadPDF } from "../../../lib/fetchApi";
import { notificationActions } from "../../../store/notifications";
import { useWorkQShell } from "../context/workQShellContext";

function MrqCoverLetterCell({ caseData }) {
    const dispatch = useDispatch();
    const shell = useWorkQShell();
    const userToken = useSelector((state) => state.user.token);
    const [loading, setLoading] = useState(false);

    const openCoverLetter = useCallback(async () => {
        if (!shell || !caseData?.case?.id) {
            return;
        }

        setLoading(true);
        try {
            const response = await generateGlobalDownloadPDF(
                userToken,
                caseData.case.id,
                "mrq-cover-letter-pdf",
            );

            if (response && response.errorMessage) {
                dispatch(notificationActions.setError(response));
                return;
            }

            if (!(response instanceof Blob)) {
                dispatch(
                    notificationActions.setError({
                        errorMessage: "Unable to generate MRQ Cover Letter PDF.",
                    }),
                );
                return;
            }

            const pdfBlobUrl = URL.createObjectURL(response);

            shell.openModal({
                kind: "modal_mrq_cover_letter",
                caseData,
                pdfBlobUrl,
            });
        } finally {
            setLoading(false);
        }
    }, [shell, caseData, userToken, dispatch]);

    return (
        <div className={`${classes.mrq_cover_letter_cell} ${classesCell.body_cell}`}>
            <Button
                title="MRQ Cover Letter"
                btnStyle="btn_simple"
                click={openCoverLetter}
                isLoading={loading}
                loaderType="dark"
            >
                <i className="ti ti-file-text" />
            </Button>
        </div>
    );
}

export default memo(MrqCoverLetterCell);
